/**
 * navStore — route interne active de l'application UNIQUE.
 * Router minimaliste basé sur Zustand (pas de dépendance react-router).
 */
import { create } from 'zustand';
import type { Task } from './types';

export type Route =
  | 'briefing'
  | 'dashboard'
  | 'focus'
  | 'commhub'
  | 'smartsave'
  | 'analytics'
  | 'settings'
  | 'pricing'
  | 'billing';

/**
 * Phases internes de l'écran focus :
 *   - pip      : fenêtre compacte 320×140 flottante (en cours de travail)
 *   - finalize : écran plein pour saisir les notes obligatoires (fin de session)
 */
export type FocusPhase = 'pip' | 'finalize';

interface NavState {
  route: Route;
  /** Tâche active pour l'écran Focus (si définie). */
  focusTask: Task | null;
  /** Phase interne de la session focus. */
  focusPhase: FocusPhase;
  navigate: (route: Route) => void;
  startFocus: (task: Task) => void;
  setFocusPhase: (phase: FocusPhase) => void;
  clearFocus: () => void;
}

export const useNavStore = create<NavState>((set) => ({
  route: 'briefing',
  focusTask: null,
  focusPhase: 'pip',
  navigate: (route) => set({ route }),
  startFocus: (task) => set({ route: 'focus', focusTask: task, focusPhase: 'pip' }),
  setFocusPhase: (phase) => set({ focusPhase: phase }),
  clearFocus: () => set({ focusTask: null, focusPhase: 'pip' }),
}));
